import { AttachmentFieldParameter } from '@integration-frontends/common/brandfolder-api';
import { AttachmentRepo } from '@integration-frontends/integration/infrastructure/isomorphic';
import { attachmentFields } from '../common/utilities';

export class AttachmentRepoPanelUiStrategy extends AttachmentRepo {
  constructor() {
    super(attachmentFields as AttachmentFieldParameter[]);
  }
}
